import React from "react";
import { useDispatch } from "react-redux";
import { Blade, Button, Input } from "rhombus-react";

import useActiveCreative from "hooks/useActiveCreative";
import { closeModal } from 'reducers/Modal';

import "./ViewRejectionReason.css";

export default function ViewRejectionReason(props){
	let dispatch = useDispatch()
		, { creatives = []} = props
		, [creative] = creatives
		, onClose = () => dispatch(closeModal())
		;

	useActiveCreative(creative?.id);

	const renderContent = () => (
		<div className="view-reject-reason-form">
			<Input
				name="reason"
				label="Rejection Reason"
				className="reject-reason-textarea"
				type="textarea"
				value={creative.rejectNotes}
				disabled
			/>
		</div>
	);

	const renderFooter = () => ([
		<Button key="cancel" theme="grey" onClick={onClose}>Close</Button>,
	]);

	return (
		<Blade
			type={"modal"}
			setAppTitle={false}
			className="view-reject-reason-modal"
			title={`Rejected by QA - ${creative.name}`}
			allowFullScreen={false}
			xClose
			bladeProps={{ verticallyCenter: true }}
			onClose={onClose}
			renderContent={renderContent}
			renderFooter={renderFooter}
		/>
	);
}

ViewRejectionReason.displayName = "ViewRejectionReason";
